function clearHoveredClasses(tableEl) {
  tableEl.querySelectorAll('.column-hover-cell').forEach((cell) => {
    cell.classList.remove('column-hover-cell')
  })
}

function applyColumnHover(tableEl, columnIndex) {
  clearHoveredClasses(tableEl)
  if (columnIndex < 0) return

  tableEl.querySelectorAll('.el-table__body-wrapper tbody tr').forEach((row) => {
    const bodyCell = row.children[columnIndex]
    if (bodyCell) bodyCell.classList.add('column-hover-cell')
  })

  tableEl.querySelectorAll('.el-table__footer-wrapper tfoot tr').forEach((row) => {
    const footerCell = row.children[columnIndex]
    if (footerCell) footerCell.classList.add('column-hover-cell')
  })
}

function resolveCell(target) {
  return target && target.closest ? target.closest('td.el-table__cell, th.el-table__cell') : null
}

export default {
  mounted(el) {
    const tableRoot = el.classList.contains('el-table') ? el : el.querySelector('.el-table')
    if (!tableRoot) return

    const onMouseOver = (event) => {
      const cell = resolveCell(event.target)
      if (!cell) return
      const row = cell.parentElement
      if (!row) return
      const columnIndex = Array.prototype.indexOf.call(row.children, cell)
      applyColumnHover(tableRoot, columnIndex)
    }

    const onMouseLeave = () => {
      clearHoveredClasses(tableRoot)
    }

    tableRoot.__columnHoverHandlers__ = {onMouseOver, onMouseLeave}
    tableRoot.addEventListener('mouseover', onMouseOver)
    tableRoot.addEventListener('mouseleave', onMouseLeave)
  },
  beforeUnmount(el) {
    const tableRoot = el.classList.contains('el-table') ? el : el.querySelector('.el-table')
    if (!tableRoot || !tableRoot.__columnHoverHandlers__) return
    const {onMouseOver, onMouseLeave} = tableRoot.__columnHoverHandlers__
    tableRoot.removeEventListener('mouseover', onMouseOver)
    tableRoot.removeEventListener('mouseleave', onMouseLeave)
    delete tableRoot.__columnHoverHandlers__
  },
}
